import rootReducer from '../data/rootReducer';
import { createStore, compose, applyMiddleware } from 'redux';
import { apiMiddleware, thunkMiddleware } from '../data/middlewares';


export default (initialState) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(
      thunkMiddleware,
      apiMiddleware(window.fetch),
    ))
  );
};


// WEBPACK FOOTER //
// ./src/utils/configureStore.js